import React, { useState } from 'react';
import { graphql } from 'gatsby';
import CtaLink from '../Global/CtaLink';
//@ts-ignore
import * as styles from './CtaBar.module.css';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import RichText from '../Global/RichText';
import {
    KontentStringValue,
    CTAConfiguration,
    KontentRadioMultiChoice,
    BrandColor,
    KontentRichText,
    CtaTsType,
} from '../../../types/KontentProps';
import { getColor, getMultiChoice } from '../Global/DataUtils';
import Jotform from '../Jotform';

interface Props extends CTAConfiguration {
    content_panel__content_panel_color?: BrandColor;
    content_panel__content_panel_font_color?: BrandColor;
    copy: KontentRichText;
    layout: {
        value: [
            {
                name: string;
            }
        ];
    };
    ctas: {
        value: CtaTsType[];
    };
    type_of_cta?: KontentRadioMultiChoice<'page_link' | 'form' | undefined>;
    form_link?: KontentStringValue;
    form_cta_label?: KontentStringValue;
}

const CtaBar: React.FC<Props> = ({
    content_panel__content_panel_color,
    content_panel__content_panel_font_color,
    ctas,
    copy,
    layout,
    type_of_cta,
    form_link,
    form_cta_label,
    ...props
}) => {
    const [showForm, setShowForm] = useState(false);
    const cta = ctas.value;
    const action = layout.value[0]?.name;
    const contentPanelColor = getColor(content_panel__content_panel_color);
    const contentPanelFontColor = getColor(
        content_panel__content_panel_font_color
    );
    const useFormLink = getMultiChoice(type_of_cta) === 'form';

    const textColor = contentPanelFontColor ? contentPanelFontColor : undefined;
    const backgroundColor = contentPanelColor ? contentPanelColor : undefined;

    const buttonComponent = () => {
        return (
            <div className={styles.ctaContainer}>
                {useFormLink ? (
                    <button
                        onClick={() => setShowForm(true)}
                        type="button"
                        style={{
                            color: textColor,
                            borderColor: textColor,
                            background: backgroundColor,
                        }}
                    >
                        {form_cta_label?.value}
                    </button>
                ) : (
                    cta.map((cta, index) => (
                        <CtaLink
                            key={index}
                            href={BuildLinkHref(
                                cta.elements.cta_location,
                                cta.elements.cta_location_anchor_point
                            )}
                            target={
                                getMultiChoice(
                                    cta.elements.cta_window_action
                                ) === 'new_window'
                                    ? '_blank'
                                    : undefined
                            }
                            color={textColor}
                        >
                            {cta.elements.cta_label.value}
                        </CtaLink>
                    ))
                )}
                {showForm && form_link?.value && (
                    <div>
                        <Jotform
                            formUrl={form_link?.value}
                            formStyle="popup"
                            display={true}
                            onPopUpClose={() => setShowForm(false)}
                        />
                    </div>
                )}
            </div>
        );
    };

    return (
        <div
            style={{
                backgroundColor: backgroundColor,
                color: textColor,
            }}
            className={styles.container}
        >
            {copy?.value != '<p><br></p>' && (
                <div className={styles.content}>{RichText(copy)}</div>
            )}
            {buttonComponent()}
        </div>
    );
};

export default CtaBar;

export const fragmentCtaBar = graphql`
    fragment CtaBar on kontent_item_component___cta_bar {
        elements {
            ctas {
                value {
                    ...kontentCta
                }
            }
            layout {
                value {
                    name
                }
            }
            copy {
                ...kontentRichText
            }
            content_panel__content_panel_font_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            content_panel__content_panel_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            type_of_cta {
                value {
                    codename
                }
            }
            form_link {
                value
            }
            form_cta_label {
                value
            }
        }
    }
`;
